import React, { useState, forwardRef } from 'react';
import { View, TextInput, StyleSheet, Platform, Pressable } from 'react-native';
import { Icons } from '@hmsexp/component-library';

const TextInputWithAdornment = forwardRef(({ onIconClick, onChangeText, value }, ref) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const getBorderColor = () => {
    if (isFocused) return '#2d77d0';
    if (isHovered) return '#2d77d0';
    return '#ccc';
  };

  return (
    <Pressable
      ref={ref}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
      style={[
        styles.container,
        {
          borderColor: getBorderColor(),
          shadowColor: isFocused ? '#2d77d0' : 'transparent'
        }
      ]}>
      <TextInput
        style={styles.textInput}
        placeholder='yyyy-mm-dd'
        value={value}
        placeholderTextColor='#9CA3AF'
        onChangeText={onChangeText}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      <Pressable onPress={onIconClick} style={styles.adornment}>
        <Icons.CalendarIcon size='M' />
      </Pressable>
    </Pressable>
  );
});

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1.5,
    borderRadius: 50,
    paddingHorizontal: 16,
    backgroundColor: '#fff',
    transition: Platform.OS === 'web' ? 'all 0.15s ease' : undefined,
    boxShadow: Platform.OS === 'web' ? '0 1px 2px rgba(0,0,0,0.05)' : undefined
  },
  textInput: {
    flex: 1,
    maxWidth:'90%',
    paddingVertical: 5,
    fontSize: 15,
    color: '#111827',
    outlineStyle: 'none'
  },
  adornment: {
    marginLeft: 8
  }
});

export default TextInputWithAdornment;
